export const getTelegramBotUrl = () =>
  process.env.REACT_APP_TELEGRAM_BOT_URL ?? 'https://t.me/PrivateGateVPNbot';

export const getTelegramBotUsername = (): string | undefined => {
  try {
    const url = new URL(getTelegramBotUrl());
    const match = /^\/([A-Za-z][A-Za-z0-9_]{4,31})\/?$/.exec(url.pathname);
    if (url.protocol !== 'https:' || url.hostname !== 't.me' || url.port
      || url.username || url.password || url.search || url.hash
      || !match || !/bot$/i.test(match[1])) return undefined;
    return match[1];
  } catch {
    return undefined;
  }
};

export const getValidatedTelegramBotUrl = (): string | undefined => {
  const username = getTelegramBotUsername();
  return username ? `https://t.me/${username}` : undefined;
};

const loginOrigin = (value: string): string | undefined => {
  try {
    const url = new URL(value);
    const development = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
    const localHttp = development && url.protocol === 'http:'
      && (url.hostname === 'localhost' || url.hostname === '127.0.0.1');
    if ((url.protocol !== 'https:' && !localHttp) || url.username || url.password
      || url.search || url.hash || (url.pathname !== '' && url.pathname !== '/')) {
      return undefined;
    }
    return url.origin;
  } catch {
    return undefined;
  }
};

// Legacy Telegram Login is enabled only on the bot's configured frontend origin.
// This restriction does not apply to ordinary bot links or account-bind deep links.
export const getTelegramLoginBotUsername = (
  origin = window.location.origin
): string | undefined => {
  const allowedOrigin = loginOrigin(
    process.env.REACT_APP_TELEGRAM_LOGIN_ORIGIN ?? 'https://cp.privategatevpn.com'
  );
  return allowedOrigin && loginOrigin(origin) === allowedOrigin
    ? getTelegramBotUsername() : undefined;
};
